import a from "./td-longtail-vue-components115.js";
/* empty css                              */
import n from "./td-longtail-vue-components98.js";
var s = function() {
  var t = this, r = t._self._c, e = t._self._setupProxy;
  return r(e.LinkButton, { staticClass: "play-pause-button", attrs: { type: "button", tag: "button", "icon-only": "", large: t.large, medium: t.medium, primary: t.primary, secondary: t.secondary }, on: { click: e.handleClick } }, [r("svg", { staticClass: "play-pause-button__svg", attrs: { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", "xml:space": "preserve", "aria-hidden": "true", fill: "currentColor" } }, [t.value ? [r("path", { attrs: { d: "M9 0v24H3V0zm12 0v24h-6V0z", "fill-rule": "nonzero" } })] : [r("path", { attrs: { d: "m3.8 0 18.4 12L3.8 24z", "fill-rule": "nonzero" } })]], 2)]);
}, o = [], l = /* @__PURE__ */ n(
  a,
  s,
  o,
  !1,
  null,
  "bc32edb4"
);
const m = l.exports;
export {
  m as default
};
